/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { insuranceServices } from "../../../../api/services/insuranceServices";
import {
  setInsuranceList,
  setInsuranceListLoader,
} from "../../../../infra/aggregates/myProfile/insuranceAggregates/insuranceListSlice";
import toast from "react-hot-toast";

interface PropsValues {
  setInsuranceListData: (data: any) => void;
}

function DTOInsuranceList({ setInsuranceListData }: PropsValues) {
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state.authSlice);
  const storeInsuranceList = useAppSelector(
    (state) => state.insuranceListSlice.insuranceList
  );
  async function getInsuranceListData(empId: number) {
    dispatch(setInsuranceListLoader(true));
    await insuranceServices
      .getInsuranceList(empId)
      .then((response: any) => {
        if (response) {
          dispatch(setInsuranceList(response?.data));
          setInsuranceListData(response?.data);
          dispatch(setInsuranceListLoader(false));
        } else {
          dispatch(setInsuranceListLoader(true));

          return;
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message));
  }
  useEffect(() => {
    if (selector.emp_id) getInsuranceListData(selector.emp_id);
  }, []);

  useEffect(() => {
    setInsuranceListData(storeInsuranceList);
  }, [storeInsuranceList]);

  return <></>;
}
export default DTOInsuranceList;
